import { Component, Inject, ViewChild, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { DialogBase, ObjectTypeClassInfo } from 't4core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, NgModel, Validators } from '@angular/forms';
import { ObjectTypeClassAttributesInfo, TypeAttributeInfo } from '../../../../../projects/t4core/src/public-api';
import { T4TranslationEditorComponent } from '../../../../t4common/components/t4-translation-editor/t4-translation-editor.component';

@Component({
  styleUrls: ['ObjectTypeClassAttributeDialog.css'],
  selector: 'ObjectTypeClassAttributeDialog',
  templateUrl: 'ObjectTypeClassAttributeDialog.html',
})

export class ObjectTypeClassAttributeDialog extends DialogBase {

  public form = new FormGroup({
    Key: new FormControl('', [Validators.required]),
    Datatype: new FormControl('', []),
    isTranslatable: new FormControl(false, []),
    Name: new FormControl(''),
    Unit: new FormControl(''),
    Shorthand: new FormControl('')
  });

  public attr = new ObjectTypeClassAttributesInfo();
  public typeClassAttr: ObjectTypeClassAttributesInfo;
  public typeAttr = new TypeAttributeInfo();
  public isAttrUpdate: boolean = false;
  public translationKey: string = '';

  @ViewChildren(T4TranslationEditorComponent) translationEditors: QueryList<T4TranslationEditorComponent>;
  constructor(
    public dialogRef: MatDialogRef<ObjectTypeClassAttributeDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super("ObjectTypeClassAttributeDialog");
    if (data.objectTypeClassAttr) {
      this.typeClassAttr = data.objectTypeClassAttr;
      this.form.setValue({
        Key: this.typeClassAttr.Key ?? '',
        Datatype: this.typeClassAttr.DataType ?? '',
        isTranslatable: this.typeClassAttr.IsTranslatable ?? false,
        Name: '',
        Unit: '',
        Shorthand: ''
      });
    }
  }
  public async ngOnInit() {
    this.isAttrUpdate = this.typeClassAttr ? true : false;
    if (this.isAttrUpdate) {
      this.translationKey = this.typeClassAttr.Key;
    }
  }
  public async save() {
    if (!this.form.valid) return;
    if (this.typeClassAttr != null) this.attr.Id = this.typeClassAttr.Id;
    if (this.data.typeClassId != null) this.attr.ObjectTypeClassId = this.data.typeClassId;
    this.attr.Key = this.form.get("Key")!.value ;
    this.attr.DataType = this.form.get("Datatype")!.value;
    this.attr.IsTranslatable = true;
    //save the translations
    this.attr.Name = `T4.Data.TypeAttribute.${this.data.typeClassId}.${this.attr.Key}.Name`;
    this.attr.Unit = `T4.Data.TypeAttribute.${this.data.typeClassId}.${this.attr.Key}.Unit`;
    this.attr.Shorthand = `T4.Data.TypeAttribute.${this.data.typeClassId}.${this.attr.Key}.Shorthand`;
 
    var token = this.UI.beginLoading("T4.Settings.ObjectTypeClassAttributeDialog.msgSaving", "Saving Object Type class attributes", null);
    var attrId = await this.Api.post<any>("Settings/SaveObjectTypeClassAttrribute", this.attr);
    //Save the translation editors.
    await this.translationEditors.forEach(tb => tb.saveTranslations());
    if (this.data.typeId) {
      this.typeAttr.AttributeId = attrId;
      this.typeAttr.RentalObjectTypeId = this.data.typeId;
      this.typeAttr.AttributeValue = null;
      var ret = await this.Api.post<any>("Settings/SaveTypeAttributes", this.typeAttr);
    }
    this.dialogRef.close(true);
    this.UI.loaderCompleted(token);
  } 
  async onKeyBlur(): Promise<void> {
    const keyValue = this.form.get("Key")!.value;
    const exists = this.data.typeClassAttributes.some(
      (attr) => attr.Key.toLowerCase() === keyValue.toLowerCase()
    );
    if (exists) {
      await this.UI.alert("T4.Data.TypeAttribute.AttrExistsHeader", "Attribute exists !", "T4.Data.TypeAttribute.AttrExistsMsg", "This attribute already exists in this product class.")
      return;
    }
    if (keyValue) {
      this.translationKey = keyValue;
    } else {
      this.translationKey = '';
    }
  }
}
